module.exports = __webpack_public_path__ + "img/MEDIA061.0b2a410d.jpg";